import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import { apiCall } from '../../helpers/MainHelper';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import './PricingManagement.css';

class PricingManagement extends Component {
  state = {
    products: [],
    loading: true,
    showModal: false,
    modalType: '', // 'create' or 'update'
    selectedProduct: null,
    selectedPlan: null,
    formData: {
      product_id: '',
      name: '',
      price: '',
      paymentInterval: 'MONTHLY',
      trialPeriodDays: 7,
      recurrenceCount: 12,
    },
    processingAction: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchProducts();
  }

  fetchProducts = async () => {
    try {
      this.setState({ loading: true });
      const response = await apiCall('business/pricing-management/list-all', 'get');

      if (response.status === 'success') {
        this.setState({ products: response.data, loading: false });
      } else {
        toast.error('Ürünler yüklenemedi');
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
      this.setState({ loading: false });
    }
  };

  handleOpenCreateModal = (product) => {
    this.setState({
      showModal: true,
      modalType: 'create',
      selectedProduct: product,
      formData: {
        product_id: product.id,
        name: '',
        price: '',
        paymentInterval: 'MONTHLY',
        trialPeriodDays: 7,
        recurrenceCount: 12,
      },
    });
  };

  handleOpenUpdateModal = (product, plan) => {
    this.setState({
      showModal: true,
      modalType: 'update',
      selectedProduct: product,
      selectedPlan: plan,
      formData: {
        product_id: product.id,
        old_reference_code: plan.referenceCode,
        new_name: plan.name,
        new_price: plan.price,
        paymentInterval: plan.paymentInterval,
      },
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalType: '',
      selectedProduct: null,
      selectedPlan: null,
      formData: {
        product_id: '',
        name: '',
        price: '',
        paymentInterval: 'MONTHLY',
        trialPeriodDays: 7,
        recurrenceCount: 12,
      },
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { modalType, formData } = this.state;

    this.setState({ processingAction: true });

    try {
      const endpoint = modalType === 'create'
        ? 'business/pricing-management/create-plan'
        : 'business/pricing-management/update-plan';

      const response = await apiCall(endpoint, 'post', formData);

      if (response.status === 'success') {
        toast.success(response.message);
        this.handleCloseModal();
        this.fetchProducts();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      this.setState({ processingAction: false });
    }
  };

  handleToggleStatus = async (product, plan) => {
    const newStatus = plan.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    try {
      const response = await apiCall('business/pricing-management/toggle-status', 'post', {
        product_id: product.id,
        reference_code: plan.referenceCode,
        status: newStatus,
      });

      if (response.status === 'success') {
        toast.success(`Plan ${newStatus === 'ACTIVE' ? 'aktif' : 'pasif'} edildi`);
        this.fetchProducts();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  formatPrice = (price) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
    }).format(price);
  };

  render() {
    const { products, loading, showModal, modalType, selectedProduct, formData, processingAction } = this.state;

    return (
      <div
        className="admin-pricing-management"
        onClick={() => {
          document.body.classList.remove('offcanvas-active');
        }}
      >
        <div className="page-loader-wrapper" style={{ display: loading ? 'block' : 'none' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="ServiceZone" />
            </div>
            <p>Yükleniyor</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
          </div>
        </div>

        <div className="container-fluid">
          <PageHeader
            HeaderText="Fiyatlandırma Yönetimi"
            Breadcrumb={[
              { name: 'Admin', navigate: '' },
              { name: 'Fiyatlandırma', navigate: '' },
            ]}
          />

          {/* Stats Overview */}
          <div className="row clearfix mb-4">
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon products">
                  <i className="fa fa-box"></i>
                </div>
                <div className="stats-content">
                  <h3>{products.length}</h3>
                  <p>Toplam Ürün</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon plans">
                  <i className="fa fa-tags"></i>
                </div>
                <div className="stats-content">
                  <h3>
                    {products.reduce((sum, product) => sum + (product.pricingPlans?.length || 0), 0)}
                  </h3>
                  <p>Toplam Plan</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="stats-card">
                <div className="stats-icon active">
                  <i className="fa fa-check-circle"></i>
                </div>
                <div className="stats-content">
                  <h3>
                    {products.reduce(
                      (sum, product) =>
                        sum + (product.pricingPlans?.filter((p) => p.status === 'ACTIVE').length || 0),
                      0
                    )}
                  </h3>
                  <p>Aktif Plan</p>
                </div>
              </div>
            </div>
          </div>

          {/* Products List */}
          <div className="row clearfix">
            {products.map((product, index) => (
              <div key={product.id} className="col-lg-12">
                <div className="product-management-card">
                  {/* Product Header */}
                  <div className="product-header">
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <span className={`product-status ${product.status?.toLowerCase()}`}>
                        {product.status || 'ACTIVE'}
                      </span>
                    </div>
                    <button
                      className="btn btn-add-plan"
                      onClick={() => this.handleOpenCreateModal(product)}
                    >
                      <i className="fa fa-plus"></i> Yeni Plan Ekle
                    </button>
                  </div>

                  {/* Pricing Plans Table */}
                  <div className="table-responsive">
                    <table className="pricing-table">
                      <thead>
                        <tr>
                          <th>Plan Adı</th>
                          <th>Fiyat</th>
                          <th>Periyot</th>
                          <th>Deneme Süresi</th>
                          <th>Tekrar Sayısı</th>
                          <th>Durum</th>
                          <th>Oluşturma Tarihi</th>
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {product.pricingPlans && product.pricingPlans.length > 0 ? (
                          product.pricingPlans.map((plan, planIndex) => (
                            <tr key={planIndex} className={plan.status === 'INACTIVE' ? 'inactive-row' : ''}>
                              <td>
                                <strong>{plan.name}</strong>
                              </td>
                              <td>
                                <span className="price-tag">{this.formatPrice(plan.price)}</span>
                              </td>
                              <td>
                                <span className={`interval-badge ${plan.paymentInterval?.toLowerCase()}`}>
                                  {plan.paymentInterval === 'MONTHLY' ? 'Aylık' : 'Yıllık'}
                                </span>
                              </td>
                              <td>{plan.trialPeriodDays} gün</td>
                              <td>{plan.recurrenceCount} kez</td>
                              <td>
                                <span className={`status-badge ${plan.status?.toLowerCase()}`}>
                                  {plan.status === 'ACTIVE' ? 'Aktif' : 'Pasif'}
                                </span>
                              </td>
                              <td>
                                {new Date(plan.createdDate).toLocaleDateString('tr-TR', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </td>
                              <td>
                                <div className="action-buttons">
                                  <button
                                    className="btn-action edit"
                                    onClick={() => this.handleOpenUpdateModal(product, plan)}
                                    title="Düzenle"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className={`btn-action toggle ${plan.status === 'ACTIVE' ? 'deactivate' : 'activate'}`}
                                    onClick={() => this.handleToggleStatus(product, plan)}
                                    title={plan.status === 'ACTIVE' ? 'Pasifleştir' : 'Aktifleştir'}
                                  >
                                    <i className={`fa fa-${plan.status === 'ACTIVE' ? 'toggle-on' : 'toggle-off'}`}></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              <div className="empty-state">
                                <i className="fa fa-inbox"></i>
                                <p>Henüz plan eklenmemiş</p>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => this.handleOpenCreateModal(product)}
                                >
                                  İlk Planı Ekle
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal for Create/Update Plan */}
        {showModal && (
          <div className="modal-overlay" onClick={this.handleCloseModal}>
            <div className="pricing-modal" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={this.handleCloseModal}>
                ×
              </button>

              <h2 className="modal-title">
                {modalType === 'create' ? 'Yeni Plan Ekle' : 'Planı Güncelle'}
              </h2>
              <p className="modal-subtitle">{selectedProduct?.name}</p>

              <form onSubmit={this.handleSubmit} className="pricing-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Plan Adı</label>
                    <input
                      type="text"
                      name={modalType === 'create' ? 'name' : 'new_name'}
                      value={formData.name || formData.new_name || ''}
                      onChange={this.handleInputChange}
                      placeholder="örn: Aylık Plan"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Fiyat (TL)</label>
                    <input
                      type="number"
                      name={modalType === 'create' ? 'price' : 'new_price'}
                      value={formData.price || formData.new_price || ''}
                      onChange={this.handleInputChange}
                      placeholder="950"
                      min="0"
                      step="0.01"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Ödeme Periyodu</label>
                    <select
                      name="paymentInterval"
                      value={formData.paymentInterval}
                      onChange={this.handleInputChange}
                      required
                    >
                      <option value="MONTHLY">Aylık</option>
                      <option value="YEARLY">Yıllık</option>
                    </select>
                  </div>

                  {modalType === 'create' && (
                    <>
                      <div className="form-group">
                        <label>Deneme Süresi (Gün)</label>
                        <input
                          type="number"
                          name="trialPeriodDays"
                          value={formData.trialPeriodDays}
                          onChange={this.handleInputChange}
                          min="0"
                        />
                      </div>

                      <div className="form-group">
                        <label>Tekrar Sayısı</label>
                        <input
                          type="number"
                          name="recurrenceCount"
                          value={formData.recurrenceCount}
                          onChange={this.handleInputChange}
                          min="1"
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn btn-cancel" onClick={this.handleCloseModal}>
                    İptal
                  </button>
                  <button type="submit" className="btn btn-submit" disabled={processingAction}>
                    {processingAction ? (
                      <>
                        <ReactLoading type="spin" color="#fff" width={20} height={20} />
                        <span>İşleniyor...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-save"></i>
                        {modalType === 'create' ? 'Plan Oluştur' : 'Planı Güncelle'}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(PricingManagement);

